import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SortDetails } from 'src/app/models/sort-details-model';
import { ResultColumnsService } from 'src/app/services/result-columns.service';
import { QueryStateService } from 'src/app/services/query-state.service';

@Component({
  selector: 'app-sort-select-panel',
  templateUrl: './sort-select-panel.component.html',
  styleUrls: ['./sort-select-panel.component.css']
})
export class SortSelectPanelComponent implements OnInit {

  @Input() selectedCols: any[] = [];
  @Input() selectedSortColumn: any;
  @Input() selectedSortDirection: any;
  @Input() selectedSortCols: any[] = [];

  @Output() executeSort = new EventEmitter<any>();
  @Output() executeSortReset = new EventEmitter<any>();

  sortDirectionOptions = [{ name: "Descending", value: -1 }, { name: "Ascending", value: 1 }];
  showSortReset: boolean = false;

  constructor(private columnsSvc: ResultColumnsService, private queryStateSvc: QueryStateService) { }

  ngOnInit(): void {
    this.columnsSvc.selectedCols$.subscribe(cols => {
      this.selectedCols = cols;

      // Restore saved sort selection once columns are available
      const savedField = this.queryStateSvc.getSortBy();
      const savedDir = this.queryStateSvc.getSortDir();

      if (savedField) {
        this.selectedSortColumn = cols.find(c => c.field === savedField) ?? null;
        this.selectedSortDirection = this.sortDirectionOptions.find(d => d.value === savedDir)
          ?? { name: 'Descending', value: -1 };
        this.showSortReset = true;
      }
    });
  }

  customSort() {
    if (this.selectedSortColumn && this.selectedSortColumn.field) {
      let sortDetails: SortDetails = { field: this.selectedSortColumn.field, order: this.selectedSortDirection.value };
      this.showSortReset = true;
      this.executeSort.emit(sortDetails);
    }
  }

  resetSort() {
    this.selectedSortColumn = '';
    this.selectedSortDirection = { name: "Descending", value: -1 };
    this.executeSortReset.emit();
  }
}
